import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CreateGroupService {
  passCounty: string;
  private addressValidation = new BehaviorSubject({ });  // to store the obj from the group serach
  addressValidationObj = this.addressValidation.asObservable();

  // constructor(private epHttpService: EpHttpService) { }

  addressValidation_Fun(obj) {
    this.addressValidation.next(obj);
  }
}
